// Constrói uma bolha "otimista" com a forma de Mensagem a partir do input de
// envio, para mostrar na conversa antes do servidor confirmar. Sem React/I/O:
// recebe id e timestamp por parâmetro (determinístico para testes). Estado de
// entrega e campos de média ficam a null = "a enviar".
import type { Mensagem, MensagemInsert } from '@/services/mensagens.service';

export function buildOptimisticMensagem(
  dados: MensagemInsert,
  orgId: string,
  id: string,
  nowIso: string,
): Mensagem {
  return {
    id,
    organization_id: orgId,
    cliente_potencial_id: dados.cliente_potencial_id,
    conteudo: dados.conteudo ?? '',
    remetente: dados.remetente,
    nome_remetente: dados.nome_remetente ?? null,
    canal: dados.canal ?? 'interno',
    criado_em: nowIso,
    status_entrega: null,
    bsp_message_id: null,
    reply_to_bsp_id: dados.reply_to_bsp_id ?? null,
    tipo_media: null,
    media_status: null,
    media_storage_path: null,
    media_mime_type: null,
    media_filename: null,
    lida: false,
    autor_id: null,
  } as Mensagem;
}

// Campos mínimos para a bolha otimista de mídia (definidos localmente para não
// importar de useMensagens — evita import circular).
export interface OptimisticMidiaInput {
  clienteId: string;
  storagePath: string;
  mimeType: string;
  filename: string;
  caption?: string;
  tipoMedia: 'image' | 'document' | 'audio';
}

// Bolha "otimista" para envio de mídia: a imagem já está no bucket (pré-upload),
// por isso media_status='ready' + storagePath mostram-na de imediato; o estado
// de entrega fica null = "a enviar".
export function buildOptimisticMidia(
  params: OptimisticMidiaInput,
  orgId: string,
  id: string,
  nowIso: string,
): Mensagem {
  return {
    id,
    organization_id: orgId,
    cliente_potencial_id: params.clienteId,
    conteudo: params.caption ?? '',
    remetente: 'atendente',
    nome_remetente: null,
    canal: 'whatsapp',
    criado_em: nowIso,
    status_entrega: null,
    bsp_message_id: null,
    reply_to_bsp_id: null,
    tipo_media: params.tipoMedia,
    media_status: 'ready',
    media_storage_path: params.storagePath,
    media_mime_type: params.mimeType,
    media_filename: params.filename,
    lida: false,
    autor_id: null,
    reacao: null,
  } as Mensagem;
}
